import { fmtNZD } from "@/lib/api";

export const QuickBadge = ({ p, testid }) => p?.pricing === "estimate"
  ? <span className="ml-2 text-[10px] uppercase tracking-wider border border-sky-400 text-sky-300 rounded px-1.5 py-0.5" data-testid={testid || `estimate-badge-${p.id}`}>Estimate</span>
  : p?.job_type === "quick"
  ? <span className="ml-2 text-[10px] uppercase tracking-wider border border-amber-400 text-amber-300 rounded px-1.5 py-0.5" data-testid={testid || `quick-badge-${p.id}`}>Quick</span>
  : null;

export const estLabel = e => {
  if (!e) return fmtNZD(0);
  const r = e.low != null && e.high != null ? ` (${fmtNZD(e.low)} to ${fmtNZD(e.high)})` : "";
  return `${fmtNZD(e.value)}${r}`;
};

export const EstValue = ({ label, testid }) => (
  <span className="italic text-sky-300 border-b border-dashed border-sky-400" title="Estimate only, not a contract" data-testid={testid}>Est. {label}</span>
);
